import Backbone from "js/libs/Backbone";
import assign from "lodash/assign";
import defer from "lodash/defer";
import noop from "lodash/noop";
import isFunction from "lodash/isFunction";
import guestStore from "js/stores/guestStore";
import hostStore from "js/stores/hostStore";
import {redirectUnauthorized} from "js/libs/url";
import log from "js/main/log";

/* ListStore */
export default Backbone.Collection.extend({
  loaded: false,
  busy: false,
  invalid: false,
  complete: false,
  updateOptions: {},
  getParams: () => {return {}},

  // ajax method which prevents a new request if a response is still pending
  update: function(options) {
    options = assign({}, this.updateOptions, options)

    if (this.busy) {
      this.invalid = true;
      this.storedOptions = options;
      return;
    }

    this.busy = true;
    this.invalid = false;

    let headers = {};
    if (this.authenticate) {
      let token = this.authenticate === "guest" ? guestStore.get("token") : hostStore.get("token");
      if (token) {
        headers["X-Nd-Token"] = token;
      } else {
        redirectUnauthorized(this.authenticate);
        return;
      }
    }

    const params = this.getParams ? this.getParams(options) : {};

    if (this.lazy) {
      params.limit = params.limit || this.limit;
      params.offset = options.reset ? 0 : this.models.length;

      if (!params.limit)
        log.warn("No limit set for lazy liststore update:", this);
    }

    if (!this.url)
      log.error(new Error("Trying to update broken object"));

    this.fetch(assign({
      data: params,
      context: this,
      headers: headers,
      success: (collection, response) => {
        this.loaded = true;
        this.busy = false;

        // empty list when response is null
        if (response === null) {
          response = [];

          if (!this.lazy)
            this.set([], options);
        }

        if (options.callback)
          options.callback(collection, response)

        /* Remember that we reached the end of the data */
        if (this.lazy && Array.isArray(response) && response.length < params.limit)
          this.complete = true;
        log.info("fetch success", this.url, response, this.complete);

        if (this.invalid)
          this.update(this.storedOptions); // hope this doesn't loop too often
      },
      error: (collection, xhr) => {
        if (xhr.status === 401 && this.authenticate) {
          redirectUnauthorized(this.authenticate);
          return;
        }
        log.error("fetch error:", xhr.status, xhr.statusText, `"${xhr.response}"`, xhr.responseURL);
        this.busy = false;
        if (this.invalid)
          this.update(this.storedOptions); // hope this doesn't loop too often
      },
      remove: false,
      merge: false,
    }, options));
  },
  deferredUpdate: function(options) {
    defer(this.update, options);
  }
});
